/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, February 2020
 */
import { Nullable } from '../types';

/**
 * A LinkedList node.
 */
export class LinkedListNode<T> {
    /**
     * Create a LinkedListNode.
     *
     * @param value The value of the node.
     * @param next The next node in the list.
     */
    constructor(public value: T, public next: Nullable<LinkedListNode<T>>) {}
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/collections/LinkedListNode.ts